<template>
  <div class="kpi-card" :class="type">
    <div class="kpi-label">{{ label }}</div>
    <div class="kpi-value">{{ value }}</div>
    <div class="kpi-sub" v-if="sub" v-html="sub"></div>
    <div v-if="delta!==null" class="kpi-delta" :class="delta>0? 'positive':'negative'">{{ delta>0?'+':'' }}{{ delta }}%</div>
  </div>
</template>

<script>
export default {
  name: 'KpiCard',
  props: {
    label: String,
    value: [String, Number],
    sub: [String],
    delta: { type: Number, default: null },
    type: { type: String, default: '' }
  }
};
</script>

<style scoped>
.kpi-card{background:var(--blue-3);padding:1rem;border-radius:1rem;min-width:180px; width: 100%;}
.kpi-label{color:#64748b}
.kpi-value{font-size:1.5rem;font-weight:700;margin-top:1rem}
.kpi-delta.positive{color:green}
.kpi-delta.negative{color:#ef4444}
.kpi-card.primary{background:linear-gradient(90deg, rgba(79,70,229,0.06), rgba(6,182,212,0.03))}
</style>